import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import ordersReducer from './store/reducers/orders';
import documentsReducer from './store/reducers/documents';
import ordersSummaryReducer from './store/reducers/ordersSummary';
import mapOrdersReducer from './store/reducers/mapOrders';
import mapCitiesReducer from './store/reducers/mapCities';
import deliveryMulchTypeReducer from './store/reducers/deliveryMulchTypes';
import deliveryDriversReducer from './store/reducers/deliveryDrivers';
import deliveryReducer from './store/reducers/delivery';
import deliveriesReducer from './store/reducers/deliveries';

const composeEnhancers = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null || compose;

const rootReducer = combineReducers({
    orders: ordersReducer,
    documents: documentsReducer,
    ordersSummary: ordersSummaryReducer,
    mapOrders: mapOrdersReducer,
    mapCities: mapCitiesReducer,
    deliveryMulchTypes: deliveryMulchTypeReducer,
    deliveryDrivers: deliveryDriversReducer,
    delivery: deliveryReducer,
    deliveries: deliveriesReducer
});

const store = createStore(rootReducer, 
    applyMiddleware(thunk)
);

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>

);

ReactDOM.render( app, document.getElementById( 'root' ) );
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js